// Recruit `nx test shared-util-model-config --watch` to check your new model configs for you
import { BodyPart, BodyPartGroup, BODY_PARTS, BODY_PART_GROUPS } from "../body-parts";
import { TissueLabel } from "../tissue-labels";
import { ModelConfigParams } from "./model-config-params";

import { body} from './body'
import { cardiac } from './cardiac'
import { colorectal, pelvis } from './colorectal-and-pelvis'
import { gynecology } from './gynecology'
import { headNeck } from './head-neck'
import { kidney } from './kidney'
import { knee } from './knee'
import { liver } from './liver'
import { lung } from './lung'
import { lungCurie } from './lung-curie'
import { neurofibroma } from './neurofibroma'
import { oesophageal } from './oesophageal'
import { orthopedic } from './orthopedic'
import { pancreas } from './pancreas'
import { prostate } from './prostate'
import { HotkeyModelMap } from "../hotkeys";

// storing the ModelConfigs in a map allows TS to verify key uniqueness for us
const MODEL_CONFIG_PARAMSS = {
  body,
  cardiac,
  colorectal,
  gynecology,
  headNeck,
  kidney,
  knee,
  liver,
  lung,
  lungCurie,
  neurofibroma,
  oesophageal,
  orthopedic,
  pelvis,
  pancreas,
  prostate,
} as const;

const BODY_PARTS_AND_GROUPS = {
  ...BODY_PARTS,
  ...BODY_PART_GROUPS,
}

export type ModelType = keyof typeof MODEL_CONFIG_PARAMSS

export class ModelConfig implements Omit<ModelConfigParams, 'bodyParts' | 'internal'> {
  readonly bodyParts: (BodyPart | BodyPartGroup)[]
  readonly checklist: readonly string[]
  readonly checklistQC: readonly string[]
  readonly defaultIntensityRange: readonly [number, number]
  readonly internal: boolean
  readonly tissueHotkeys?: HotkeyModelMap

  constructor(
    readonly name: ModelType,
    {bodyParts, checklist, checklistQC, defaultIntensityRange, internal, tissueHotkeys}: ModelConfigParams,
  ) {
    this.bodyParts = bodyParts.map(bp => BODY_PARTS_AND_GROUPS[bp])
    this.checklist = checklist
    this.checklistQC = checklistQC
    this.defaultIntensityRange = defaultIntensityRange
    this.internal = !!internal
    this.tissueHotkeys = tissueHotkeys
  }

  get labels(): TissueLabel[] {
    return [...new Set(this.bodyParts.flatMap(bp => bp.labels))]
  }

  get allBodyParts(): (BodyPart | BodyPartGroup)[] {
    return this.bodyParts.flatMap(bp => 'children' in bp ? [bp, ...bp.children] : [bp])
  }
}

export const MODEL_CONFIGS = Object.fromEntries(
  Object.entries(MODEL_CONFIG_PARAMSS).map(([name, config]) =>
    [name as ModelType, new ModelConfig(name as ModelType, config)]
  )
) as Readonly<Record<ModelType, ModelConfig>>
export const MODEL_TYPES = Object.keys(MODEL_CONFIGS) as ModelType[]
